import { atomWithSessionStorage } from '../../../common/util';

export const wdyrAtom = atomWithSessionStorage<boolean>('isWdyrEnabled', false);
